<div class="similar-ann">
  <a
    class="similar-ann__title"
    [routerLink]="[
      '/announcement',
      similarAnnouncement.announcementId,
      similarAnnouncement.urlFriendlyTitle
    ]"
    (click)="onSimilarAnnouncement()"
  >
    <span class="similar-ann__title-text">{{ similarAnnouncement.title }}</span>
  </a>

  @if (similarAnnouncement.locations?.length > 0) {
  <div class="similar-ann__location">
    <svg-icon
      class="similar-ann__location-icon"
      src="assets/icons/location-pin.svg"
      [svgClass]="'similar-ann__pin'"
    ></svg-icon>
    <span class="similar-ann__location-text">
      {{ similarAnnouncement.locations.join(', ') }}
    </span>
  </div>
  }

  @if (!similarAnnouncement.isAnonymous) {
  <a
    class="similar-ann__customer similar-ann__customer--link"
    [routerLink]="[
      '/customer',
      similarAnnouncement.customerId,
      similarAnnouncement.urlFriendlyCustomerName
    ]"
  >
    {{ similarAnnouncement.customerName }}
  </a>
  } @else {
  <span class="similar-ann__customer">
    {{ similarAnnouncement.customerName }}
  </span>
  }
</div>
